import { Pipe, PipeTransform } from '@angular/core';
import { ClosingEntryAccount } from '../domain/models/fcpClosingEntryAccount.model';

@Pipe({
    name: 'getTextForAccount',
})
export class GetTextForAccountPipe implements PipeTransform {
    transform(accountId: string, accounts: ClosingEntryAccount[]): string {
        if (!accountId) {
            return '';
        }
        if (!accounts || accounts.length === 0) {
            return accountId;
        }

        const account = accounts.find((acc) => acc.number === accountId);
        return account ? account.number + ' ' + account.name : account + ' Unknown Account';
    }
}
